if (!customElements.get("variant-selects")) {
  customElements.define(
    "variant-selects",
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange.bind(this));
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll(
            "select option[selected], fieldset input:checked"
          )
        ).map(({ dataset }) => dataset.optionValueId);
      }

      getInputForEventTarget(target) {
        return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        // Run validation on load to fix any invalid server-rendered states
        this.validateAndFixSelection();
      }

      onVariantChange(event) {
        const target = this.getInputForEventTarget(event.target);

        // We still attempt to fix downstream options on change,
        // though strictly relying on server response (via connectedCallback) is more robust.
        // This helps if there are local immediate updates.
        this.updateSelectedSwatchValue(event);

        // Extract variant SKU from data attribute if available
        const variantSku = target.dataset.variantSku || null;

        // Store the ID of the option the user just interacted with
        if (target.id) {
          window._lastInteractedOptionId = target.id;
        }

        FoxTheme.pubsub.publish(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
              variantSku: variantSku,
            },
          }
        );
      }

      validateAndFixSelection() {
        const lastId = window._lastInteractedOptionId;
        const inputWrappers = Array.from(
          this.querySelectorAll(".product-form__input")
        );

        for (const wrapper of inputWrappers) {
          const selectedRadio = wrapper.querySelector(
            'input[type="radio"]:checked'
          );

          // Skip auto-fix for the option the user just clicked
          if (selectedRadio && selectedRadio.id === lastId) continue;

          // If the currently selected option is disabled/unavailable
          if (
            selectedRadio &&
            (selectedRadio.classList.contains("disabled") ||
              selectedRadio.disabled)
          ) {
            // Find the first available sibling in the same group
            const availableRadio = Array.from(
              wrapper.querySelectorAll('input[type="radio"]')
            ).find(
              (radio) =>
                !radio.classList.contains("disabled") && !radio.disabled
            );

            // If found, select it and trigger change to fetch correct variant data
            if (availableRadio) {
              availableRadio.checked = true;
              availableRadio.dispatchEvent(
                new Event("change", { bubbles: true })
              );

              // Stop after fixing the first error to avoid rapid-fire events.
              // The next render cycle will fix subsequent errors if any.
              return;
            }
          }
        }
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === "SELECT" && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute("selected"))
            .removeAttribute("selected");
          target.selectedOptions[0].setAttribute("selected", "selected");

          const swatchValue =
            target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest(".product-form__input")
            .querySelector("[data-selected-value] > .swatch");
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              swatchValue
            );
            selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
          } else {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              "unset"
            );
            selectedDropdownSwatchValue.classList.add("swatch--unavailable");
          }

          selectedDropdownSwatchValue.style.setProperty(
            "--swatch-focal-point",
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
          );
        } else if (tagName === "INPUT" && target.type === "radio") {
          const selectedSwatchValue = target
            .closest(`.product-form__input`)
            .querySelector("[data-selected-value]");
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
